import { sortBy } from 'lodash';
import { mapHash } from 'cityads-v3/utils/arrayUtils'
import { mapObjectize, HTTP_STATUS_OK } from 'cityads-v3/utils/apiUtils'
import { OfferConnectRequestStatusId } from 'cityads-v3/types/offers'
import config from 'cityads-v3/config';

import {
  SET_GET_LINK_FORM,
  CLEAR_OFFER_LIST,
  CLEAR_COUPON_LIST,

  GET_FAVORITES,
  GET_FAVORITES_SUCCESS,
  GET_FAVORITES_FAIL,
  SET_FAVORITE,
  SET_FAVORITE_SUCCESS,
  SET_FAVORITE_FAIL,

  GET_ACTION_TYPE_DIRECTIONS,
  GET_ACTION_TYPE_DIRECTIONS_SUCCESS,
  GET_ACTION_TYPE_DIRECTIONS_FAIL,

  GET_CATEGORIES,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAIL,

  GET_COUPON_CATEGORIES,
  GET_COUPON_CATEGORIES_SUCCESS,
  GET_COUPON_CATEGORIES_FAIL,

  GET_OFFER_TAGS,
  GET_OFFER_TAGS_SUCCESS,
  GET_OFFER_TAGS_FAIL,

  GET_REGIONS,
  GET_REGIONS_SUCCESS,
  GET_REGIONS_FAIL,

  GET_TOOLS,
  GET_TOOLS_SUCCESS,
  GET_TOOLS_FAIL,

  GET_OFFERS,
  GET_OFFERS_SUCCESS,
  GET_OFFERS_FAIL,

  GET_COUPONS,
  GET_COUPONS_SUCCESS,
  GET_COUPONS_FAIL,

  CONNECT_TO_OFFER_SUCCESS,

  GET_CONNECT_REQUESTS_SUCCESS,

  GET_OFFER_BY_ID,
  GET_OFFER_BY_ID_SUCCESS,
  GET_OFFER_BY_ID_FAIL,

  GET_OFFERS_BY_IDS,
  GET_OFFERS_BY_IDS_SUCCESS,
  GET_OFFERS_BY_IDS_FAIL,

  GET_OFFER_LIST,
  GET_OFFER_LIST_SUCCESS,
  GET_OFFER_LIST_FAIL,

  GET_COUPON_OFFERS,
  GET_COUPON_OFFERS_SUCCESS,
  GET_COUPON_OFFERS_FAIL,

  GET_TARGETS,
  GET_TARGETS_SUCCESS,
  GET_TARGETS_FAIL,

  GET_OFFER_STAT,
  GET_OFFER_STAT_SUCCESS,
  GET_OFFER_STAT_FAIL,

  GET_USER_OFFER_HOLD,
  GET_USER_OFFER_HOLD_SUCCESS,
  GET_USER_OFFER_HOLD_FAIL,

  GET_FILTER_COUNT,
  GET_FILTER_COUNT_SUCCESS,
  GET_FILTER_COUNT_FAIL,

  GET_PROMO_ACTION_TYPES,
  GET_PROMO_ACTION_TYPES_SUCCESS,
  GET_PROMO_ACTION_TYPES_FAIL,

  GET_PROMO_COUPON_STATUSES,
  GET_PROMO_COUPON_STATUSES_SUCCESS,
  GET_PROMO_COUPON_STATUSES_FAIL,

  GET_PROMO_COUPON_SCOPES,
  GET_PROMO_COUPON_SCOPES_SUCCESS,
  GET_PROMO_COUPON_SCOPES_FAIL,

  GET_COUPON_FEED_LINK,
  GET_COUPON_FEED_LINK_SUCCESS,
  GET_COUPON_FEED_LINK_FAIL,

  GET_COUPON_LINK,
  GET_COUPON_LINK_SUCCESS,
  GET_COUPON_LINK_FAIL,

  GET_COUPON_SECTORING,
  GET_COUPON_SECTORING_SUCCESS,
  GET_COUPON_SECTORING_FAIL,

  SEND_SUGGEST_FORM,
  SEND_SUGGEST_FORM_SUCCESS,
  SEND_SUGGEST_FORM_FAIL,
  CLEAR_SUGGEST_OFFER_FORM_STATE,

} from "../actions/offers";

import {
  GET_WM_OFFER_URLS,
} from "../actions/wmOfferUrls";

import {
  GET_WM_OFFER_SUBSCRIPTION,
  GET_WM_OFFER_SUBSCRIPTION_SUCCESS,
} from "../actions/wmOfferSubscription";

import {
  LOAD_COUPON_SECTORS_SUCCESS,
} from "../actions/couponSectors";

import {
  GET_SUBSCRIPTION_STATUSES_SUCCESS,
} from "../actions/subscriptionStatuses";

import {
  GET_SADUKA_LANGUAGES,
  GET_SADUKA_LANGUAGES_SUCCESS,
  GET_SADUKA_LANGUAGES_FAIL,
} from '../actions/language';

export const ACTION_TYPE_DIRECTION_ID_WEB = 1;
export const ACTION_TYPE_DIRECTION_ID_MOBILE = 2;
export const ACTION_TYPE_DIRECTION_ID_API = 4;

export const PLATFORM_ID_IOS = 1;
export const PLATFORM_ID_ANDROID = 2;
export const PLATFORM_ID_MULTI = 4;

export const COUPON_STATUS_ID_COMING_SOON = 0;
export const COUPON_STATUS_ID_ACTIVE      = 1;
export const COUPON_STATUS_ID_EXPIRING    = 2;
export const COUPON_STATUS_ID_NEW         = 3;
export const COUPON_STATUS_ID_FINISHED    = 4;

export const ACTION_STATUS_STOPPED  = 0;
export const ACTION_STATUS_WORKING  = 1;
export const ACTION_STATUS_TESTING  = 2;
export const ACTION_STATUS_STOPPING = 3;

export const SUBSCRIPTION_STATUS_ID_AVAILABLE   = 1;
export const SUBSCRIPTION_STATUS_ID_UNCONNECTED = 2;
export const SUBSCRIPTION_STATUS_ID_BLOCKED     = 3;
export const SUBSCRIPTION_STATUS_ID_PENDING     = 4;

export const TOOL_ID_LANDING        = 1;
export const TOOL_ID_BANNERS        = 2;
export const TOOL_ID_BANNER_ROTATOR = 4;
export const TOOL_ID_COUPONS        = 7;
export const TOOL_ID_GOODS_FEED     = 8;
export const TOOL_ID_GOODS          = 9;
export const TOOL_ID_FINANCE_API    = 10;
export const TOOL_ID_WIDGETS        = 12;

export const OFFER_DESCRIPTION_TYPE_ID_FULL  = 1;
export const OFFER_DESCRIPTION_TYPE_ID_PROMO = 2;

const ACTION_TYPE_ICONS = {
  [ACTION_TYPE_DIRECTION_ID_WEB]: 'laptop_mac',
  [ACTION_TYPE_DIRECTION_ID_MOBILE]: 'smartphone',
  [ACTION_TYPE_DIRECTION_ID_API]: 'settings_ethernet',
};

export const TOOL_ID_LINKS = 1;
export const TOOL_ID_FIRANO = 10;

export const GEO_ID_WORLD = 4789;
export const GEO_ID_CIS = 4788;
export const GEO_ID_RUSSIA = 186;

let view = 'list';

const initialState = {
  accessRequested: {},
  category_id: [],
  categoriesById: {},
  coupon_category_id: [],
  coupon_categoriesById: {},
  couponFeedLink: '',
  couponFeedId: 0,
  couponLinksByCouponId: {},
  coupon_offer: [],
  couponOffersById: {},
  couponSectorsById: {},
  couponShortLinkByCouponId: {},
  currentVertical: 0,
  action_type_direction: [],
  action_type_directionById: {},
  platform: [PLATFORM_ID_IOS, PLATFORM_ID_ANDROID, PLATFORM_ID_MULTI],
  platformById: {
    [PLATFORM_ID_IOS]: {
      value: 1,
      icon: 'phone_iphone',
      title: 'iOS',
      name: 'iOS',
    },
    [PLATFORM_ID_ANDROID]: {
      value: 2,
      icon: 'phone_android',
      title: 'Android',
      name: 'Android',
    },
    [PLATFORM_ID_MULTI]: {
      value: 4,
      icon: 'devices_other',
      title: 'Multi',
      name: 'Multi',
    },
  },
  filterTotal: {
    isLoading: false,
    requestFilterTotal: false,
    total: 0,
  },
  getLinkForm: {},
  isLoadingOfferById: {},
  offerLoadingStatusById: {},
  isLoadingOffersByIds: [],
  meta: {
    total: 0,
    limit: 20,
    page: 1,
  },
  metaCoupons: {
    total: 0,
    limit: 20,
    page: 1,
  },
  offers: [],
  coupons: [],
  offersById: {},
  offerListById: {},
  isLoadingOfferList: {},
  couponsById: {},
  offersGlobalTotal: 0,
  favoriteOffersGlobalTotal: 0,
  offerSubscriptionsById: {},
  offerSubscriptionIdsByOfferId: {},
  offerStatByOfferId: {},
  userOfferHoldByOfferId: {},
  offerFavoritesByOfferId: {},
  offerFavoritesStateByOfferId: {},
  descriptionsById: {},
  descriptionsStateById: {},
  promoActionTypesById: {},
  promoCouponStatusesById: {},
  promoCouponScopesById: {},
  region_id: [],
  regionsById: {},
  regionsByCode: {},
  scopes: [],
  sectoring: [],
  subscription_status: [],
  subscription_status_byId: {},
  targetsByOfferId: {},
  traffic_type_id: [],
  trafficTypesById: {},
  tool_id: [],
  toolsById: {},
  allTools: [],
  tags: [],
  offerTagsByCode: {},
  types: [{
    id: 1,
    title: 'Избранные',
  }],
  view,

  isSuggestFormSending: false,
  isSuggestFormSent: false,
  suggestFormError: false
};

export function mapDir(item, children = 'children') {
  const newItem = {
    ...item,
    value: item.id,
    title: item.name,
    items: item[children] ? item[children].map(item => mapDir(item, children)) : null
  };

  if(children !== 'items') {
    delete newItem[children];
  }

  return newItem;
}

function prepareOffer(item, {action, state}) {
  return {
    ...item,
    id: +item.id,
    action_type_direction_id: +item.action_type_direction_id,
    business_category: +item.business_category,
    startDate: item.date_start * 1000,
    is_deeplink_enabled: !!+item.is_deeplink_enabled,
    shop_id: +item.shop_id,
    descriptions: item.descriptions ? item.descriptions.map(item => +item) : null,
    tools: item.tools ? item.tools.map(item => +item) : null,
    regions: item.regions ? item.regions.map(item => +item) : null,
    status: +item.status,
    commission_data: item.commission_data ?
      {
        amount: item.commission_data.amount ? {
          min: +item.commission_data.amount.min || 0,
          max: +item.commission_data.amount.max || 0,
        } : null,
        currency_id: +item.commission_data.currency_id,
        webmaster_currency_amount: item.commission_data.webmaster_currency_amount ? {
          min: +item.commission_data.webmaster_currency_amount.min || 0,
          max: +item.commission_data.webmaster_currency_amount.max || 0,
        } : null,
        webmaster_currency_id: +item.commission_data.webmaster_currency_id,
        percent: item.commission_data.percent ? {
          min: +item.commission_data.percent.min || 0,
          max: +item.commission_data.percent.max || 0,
        } : null,
      } :
      null,
    has_agreement_with_ord: !!+item.has_agreement_with_ord,
  };
}

function prepareCoupon(item) {
  const geos = item.geos ? item.geos.map(item => +item) : null;
  return {
    ...item,
    id: +item.id,
    category: +item.category,
    is_exclusive: !!+item.is_exclusive,
    geos,
    regions: item.geos ? item.geos.map(item => +item) : null,
    tags: Boolean(Number(item.is_exclusive)) ? ['exclusive'] : [],
    status: item.status ? item.status.map(item => +item) : null,
    promo_action_type: +item.promo_action_type,
    timezone: +item.timezone,
    language_id: +item.language_id,
  };
}

export default function offers(state = initialState, action = {}) {
  switch (action.type) {

    case GET_FAVORITES:
      return {
        ...state,
        offerFavoritesStateByOfferId: {
          ...state.offerFavoritesStateByOfferId,
          ...action.additional.offerIds.reduce((acc, offerId) => ({ ...acc, [offerId]: 'loading' }), {}),
        },
      };

    case GET_FAVORITES_SUCCESS:
      return {
        ...state,
        offerFavoritesByOfferId: {
          ...state.offerFavoritesByOfferId,
          ...action.additional.offerIds.reduce((acc, offerId) => ({ ...acc, [offerId]: false }), {}),
          ...action.response.favoriteOffer.reduce((acc, { offer_id }) => ({ ...acc, [offer_id]: true }), {}),
        },
        offerFavoritesStateByOfferId: {
          ...state.offerFavoritesStateByOfferId,
          ...action.additional.offerIds.reduce((acc, offerId) => ({ ...acc, [offerId]: 'ready' }), {}),
        },
      };

    case GET_FAVORITES_FAIL:
      return {
        ...state,
        offerFavoritesStateByOfferId: {
          ...state.offerFavoritesStateByOfferId,
          ...action.additional.offerIds.reduce((acc, offerId) => ({ ...acc, [offerId]: null }), {}),
        },
      };

    case SET_FAVORITE:
      return {
        ...state,
        offerFavoritesByOfferId: {
          ...state.offerFavoritesByOfferId,
          [action.additional.offerId]: action.additional.isFavorite,
        },
        offerFavoritesStateByOfferId: {
          ...state.offerFavoritesStateByOfferId,
          [action.additional.offerId]: 'updating',
        },
      };

    case SET_FAVORITE_SUCCESS:
      return {
        ...state,
        offerFavoritesStateByOfferId: {
          ...state.offerFavoritesStateByOfferId,
          [action.additional.offerId]: 'ready',
        },
      };

    case SET_FAVORITE_FAIL:
      return {
        ...state,
        offerFavoritesByOfferId: {
          ...state.offerFavoritesByOfferId,
          [action.additional.offerId]: !action.additional.isFavorite, // откатываемся к прежнему значению
        },
        offerFavoritesStateByOfferId: {
          ...state.offerFavoritesStateByOfferId,
          [action.additional.offerId]: 'ready',
        },
      };

    case GET_ACTION_TYPE_DIRECTIONS:
      return {
        ...state,
        isLoadingActionTypeDirections: true,
        isLoadedActionTypeDirections: false
      };
    case GET_ACTION_TYPE_DIRECTIONS_SUCCESS:
      const actionTypeDirections = action.response.actionTypeDirection.map(item => {
        return {
          ...item,
          title: item.name,
          value: item.id,
          icon: ACTION_TYPE_ICONS[item.id],
        }
      });
      const action_type_directionById = mapObjectize(actionTypeDirections);
      return {
        ...state,
        action_type_direction: actionTypeDirections.map(item => item.id),
        action_type_directionById,
        isLoadingActionTypeDirections: false,
        isLoadedActionTypeDirections: true
      };
    case GET_ACTION_TYPE_DIRECTIONS_FAIL:
      return {
        ...state,
        isLoadingActionTypeDirections: false,
        isLoadedActionTypeDirections: false
      };

    /**
     * @deprecated use categoryTree from actions/entity
     */
    case GET_CATEGORIES:
      return {
        ...state,
        isLoadingCategories: true,
        isLoadedCategories: false
      };
    case GET_CATEGORIES_SUCCESS:
      const category_id = mapHash(action.response.category.children, 'category_ids');
      const categoriesById = mapObjectize(category_id, 'value');
      return {
        ...state,
        category_id,
        categoriesById,
        isLoadingCategories: false,
        isLoadedCategories: true
      };
    case GET_CATEGORIES_FAIL:
      return {
        ...state,
        isLoadingCategories: false,
        isLoadedCategories: false
      };

    case GET_COUPON_CATEGORIES:
      return {
        ...state,
        isLoadingCouponCategories: true,
        isLoadedCouponCategories: false
      };
    case GET_COUPON_CATEGORIES_SUCCESS:
      const coupon_category_id = mapHash(action.response.category.children, 'category_ids');
      const coupon_categoriesById = mapObjectize(coupon_category_id, 'value');
      return {
        ...state,
        coupon_category_id,
        coupon_categoriesById,
        isLoadingCouponCategories: false,
        isLoadedCouponCategories: true
      };
    case GET_COUPON_CATEGORIES_FAIL:
      return {
        ...state,
        isLoadingCouponCategories: false,
        isLoadedCouponCategories: false
      };

    case GET_OFFER_TAGS:
      return {
        ...state,
        isLoadingOfferTags: true
      };
    case GET_OFFER_TAGS_SUCCESS:
      const tags = action.response.offerTag
        .map(item => {
          return {
            ...item,
            is_visible_to_non_bloggers: item.is_visible_to_non_bloggers ?? true, // если свойства нет, значит у нас нет прав на его просмотр и мы видим только true
            is_visible_to_bloggers: item.is_visible_to_bloggers ?? false, // а здесь скорее не видим, чем видим
            languages: item.languages ?? [],
            title: item.translated_name || item.name,
            value: item.code
          }
        })
        .filter(({ languages }) => !languages.length || languages.includes(action.additional.language))
      ;
      const offerTagsByCode = mapObjectize(tags, 'code');
      return {
        ...state,
        tags,
        offerTagsByCode,
        isLoadingOfferTags: false,
        isLoadedOfferTags: true,
      };
    case GET_OFFER_TAGS_FAIL:
      return {
        ...state,
        isLoadingOfferTags: false
      };

    case GET_REGIONS:
      return {
        ...state,
        isLoadingGeo: true
      };
    case GET_REGIONS_SUCCESS:
      const regions = action.response.geo.map(item => mapDir(item, 'children'));
      const regionsById = mapObjectize(regions);
      const regionsByCode = Object.values(regionsById).reduce((prev, next) => ({
        ...prev,
        [next.code]: next.id
      }), {});
      return {
        ...state,
        region_id: regions,
        regionsById,
        regionsByCode,
        isLoadingGeo: false,
        isLoadedRegions: true
      };
    case GET_REGIONS_FAIL:
      return {
        ...state,
        isLoadingGeo: false
      };

    case GET_TOOLS:
      return {
        ...state,
        isLoadingTools: true,
        isLoadedTools: false
      };
    case GET_TOOLS_SUCCESS:
      const allTools = action.response.tool.map(item => {
        return {
          ...item,
          id   : +item.id,
          title: item.name,
          value: item.id,
          is_active   : Boolean(Number(item.is_active)),
          offers_count: Number(item.offers_count),
        }
      });
      const tool_id = allTools.filter(item => item.offers_count > 0).sort((a,b) => {
        return +a.sort - +b.sort;
      });
      const toolsById = mapObjectize(allTools);
      return {
        ...state,
        tool_id,
        toolsById,
        isLoadingTools: false,
        isLoadedTools: true
      };
    case GET_TOOLS_FAIL:
      return {
        ...state,
        isLoadingTools: false,
        isLoadedTools: false
      };

    case GET_OFFERS:
      return {
        ...state,
        isLoadingOffers: true,
        meta: {
          ...state.meta,
          limit: +action.additional.limit,
          withFilters: action.additional.withFilters
        }
      };
    case GET_OFFERS_SUCCESS:
      const offers = action.response.offer.map(item => prepareOffer(item, {action, state}));

      return {
        ...state,
        offers: offers.map(item => item.id),
        offersById: {
          ...state.offersById,
          ...mapObjectize(offers, 'id')
        },
        meta: {
          ...state.meta,
          total: +action.response.meta.total,
          page: +action.additional.page
        },
        isLoadingOffers: false,
      };
    case GET_OFFERS_FAIL:
      return {
        ...state,
        ...(action.payload.name === 'AbortError' ? [] : {
          offers: [],
          isLoadingOffers: false
        }),
      };

    case GET_COUPONS:
      return {
        ...state,
        isLoadingCoupons: true,
        metaCoupons: {
          ...state.metaCoupons,
          limit: +action.additional.limit,
          withFilters: action.additional.withFilters
        }
      };
    case GET_COUPONS_SUCCESS:
      const coupons = action.response.promoCoupon.map(item => prepareCoupon(item, {action, state}));

      return {
        ...state,
        coupons: coupons.map(item => item.id),
        couponsById: {
          ...state.couponsById,
          ...mapObjectize(coupons, 'id')
        },
        metaCoupons: {
          ...state.metaCoupons,
          total: +action.response.meta.total,
          page: +action.additional.page
        },
        isLoadingCoupons: false,
      };
    case GET_COUPONS_FAIL:
      return {
        ...state,
        isLoadingCoupons: false,
        coupons: []
      };

    case GET_COUPON_OFFERS:
      return {
        ...state,
        isLoadedCouponOffers: true,
      };

    case GET_OFFER_BY_ID:
      return {
        ...state,
        isLoadingOfferById: {
          ...state.isLoadingOfferById,
          [action.additional.id]: true,
        },
        offerLoadingStatusById: {
          ...state.offerLoadingStatusById,
          [action.additional.id]: null,
        },
      };

    case GET_OFFER_BY_ID_SUCCESS:
      return {
        ...state,
        offersById: {
          ...state.offerId,
          [action.additional.id]: prepareOffer(action.response.offer, {action, state})
        },
        isLoadingOfferById: {
          ...state.isLoadingOfferById,
          [action.additional.id]: false,
        },
        offerLoadingStatusById: {
          ...state.offerLoadingStatusById,
          [action.additional.id]: HTTP_STATUS_OK,
        },
      };


    case GET_OFFER_BY_ID_FAIL:
      return {
        ...state,
        isLoadingOfferById: {
          ...state.isLoadingOfferById,
          [action.additional.id]: false,
        },
        offerLoadingStatusById: {
          ...state.offerLoadingStatusById,
          [action.additional.id]: action.response.status,
        },
      };

    case GET_COUPON_OFFERS_SUCCESS:
      const coupon_offer = action.response.offer
        .map(item => prepareOffer(item, {action, state}))
        .map(item => ({
          ...item,
          title: item.translated_name || item.name, /** @deprecated */
          value: item.id,
        }));
      const couponOffersById = mapObjectize(coupon_offer, 'id');

      return {
        ...state,
        coupon_offer: coupon_offer.map(item => item.id),
        couponOffersById,
        isLoadedCouponOffers: false,
      };
    case GET_COUPON_OFFERS_FAIL:
      return {
        ...state,
        isLoadedCouponOffers: false
      };

    case GET_TARGETS:
      const targetsByOffer = [];
      targetsByOffer.isLoading = true;
      return {
        ...state,
        targetsByOfferId: {
          ...state.targetsByOfferId,
          [action.additional.id]: targetsByOffer
        }
      };
    case GET_TARGETS_SUCCESS:
      const offerId = action.additional.id;
      const targets = action.response.offerTarget.map(item => ({
        ...item,
        currency_id: +item.currency_id,
        epa_percent: item.epa_percent && Number(item.epa_percent),
        per_sales_show: item.per_sales_show && Number(item.per_sales_show),
        per_sales_show_max: item.per_sales_show_max && Number(item.per_sales_show_max),
        webmaster_commission: item.webmaster_commission && Number(item.webmaster_commission),
        show_percent: Boolean(item.show_percent),
        webmaster_currency_amount: item.webmaster_currency_amount && {
          min: Number(item.webmaster_currency_amount.min),
          max: Number(item.webmaster_currency_amount.max),
        },
        webmaster_currency_id: +item.webmaster_currency_id,
        service_regions: item.service_regions.map(id => +id),
        restriction_regions: item.restriction_regions.map(id => +id),
      }));

      targets.sort((t1, t2) => t1.sort - t2.sort);

      return {
        ...state,
        targetsByOfferId: {
          ...state.targetsByOfferId,
          [offerId]: targets
        }
      };
    case GET_TARGETS_FAIL:
      return {
        ...state,
        targetsByOfferId: {
          ...state.targetsByOfferId,
          [action.additional.id]: null
        }
      };

    case GET_OFFER_STAT:
      const data = {};
      action.additional.ids.forEach(id => {
        data[id] = {isLoading: true};
      });
      return {
        ...state,
        offerStatByOfferId: {
          ...state.offerStatByOfferId,
          ...data
        }
      };
    case GET_OFFER_STAT_SUCCESS:
      return {
        ...state,
        offerStatByOfferId: {
          ...state.offerStatByOfferId,
          ...mapObjectize(action.response.offerStatIndicators, 'offer_id'),
        }
      };
    case GET_OFFER_STAT_FAIL:
      const dataFail = {};
      action.additional.ids.forEach(id => {
        dataFail[id] = null;
      });
      return {
        ...state,
        offerStatByOfferId: {
          ...state.offerStatByOfferId,
          ...dataFail
        }
      };

    case GET_USER_OFFER_HOLD:
      return {
        ...state,
        userOfferHoldByOfferId: {
          ...state.userOfferHoldByOfferId,
          [action.additional.offerId]: { isLoading: true },
        },
      };
    case GET_USER_OFFER_HOLD_SUCCESS:
      return {
        ...state,
        userOfferHoldByOfferId: {
          ...state.userOfferHoldByOfferId,
          [action.additional.offerId]: {
            isLoaded: true,
            ...(action.response.userToOfferHold[0] ?? { user_id: action.additional.userId }),
          },
        }
      };
    case GET_USER_OFFER_HOLD_FAIL:
      return {
        ...state,
        userOfferHoldByOfferId: {
          ...state.userOfferHoldByOfferId,
          [action.additional.offerId]: null,
        },
      };

    case GET_FILTER_COUNT:
      return {
        ...state,
        filterTotal: {
          ...state.filterTotal,
          isLoading: true,
          requestFilterTotal: false,
        }
      };
    case GET_FILTER_COUNT_SUCCESS:
      const isFavoriteFilter = action.additional.params.filter && action.additional.params.filter.is_favorite;

      return {
        ...state,
        offersGlobalTotal: (!isFavoriteFilter && action.additional.total) ? action.response.meta.total : state.offersGlobalTotal,
        favoriteOffersGlobalTotal: (isFavoriteFilter && action.additional.total) ? action.response.meta.total : state.favoriteOffersGlobalTotal,
        filterTotal: {
          ...state.filterTotal,
          isLoading: false,
          requestFilterTotal: false,
          total: action.response.meta.total
        }
      };
    case GET_FILTER_COUNT_FAIL:
      return {
        ...state,
        filterTotal: {
          ...state.filterTotal,
          isLoading: false,
          requestFilterTotal: false,
        }
      };

    case GET_PROMO_ACTION_TYPES:
      return {
        ...state,
        isLoadedPromoActionTypes: false
      };
    case GET_PROMO_ACTION_TYPES_SUCCESS:
      const promo_type = action.response.promoActionType.map(item => {
        return {
          ...item,
          id: +item.id,
          title: item.name,
          value: +item.id
        }
      });
      const promoActionTypesById = mapObjectize(promo_type)
      return {
        ...state,
        isLoadedPromoActionTypes: true,
        promo_type,
        promoActionTypesById
      };
    case GET_PROMO_ACTION_TYPES_FAIL:
      return {
        ...state,
        isLoadedPromoActionTypes: false
      };

    case GET_PROMO_COUPON_STATUSES:
      return {
        ...state,
        isLoadedPromoCouponStatuses: false
      };
    case GET_PROMO_COUPON_STATUSES_SUCCESS:
      const coupon_status = action.response.promoCouponStatus.map(item => {
        return {
          ...item,
          id: +item.id,
          title: item.name,
          value: +item.id,
          default: !!+item.is_default
        }
      });
      const promoCouponStatusesById = mapObjectize(coupon_status)
      return {
        ...state,
        isLoadedPromoCouponStatuses: true,
        coupon_status,
        promoCouponStatusesById
      };
    case GET_PROMO_COUPON_STATUSES_FAIL:
      return {
        ...state,
        isLoadedPromoCouponStatuses: false
      };

    case GET_PROMO_COUPON_SCOPES:
      return {
        ...state,
        isLoadedPromoCouponScopes: false
      };
    case GET_PROMO_COUPON_SCOPES_SUCCESS:
      const couponScopes = action.response.promoCouponScope.map(item => {
        return {
          ...item,
          title: item.name,
          value: item.id,
        }
      });
      const promoCouponScopesById = mapObjectize(couponScopes)
      return {
        ...state,
        isLoadedPromoCouponScopes: true,
        couponScopes,
        promoCouponScopesById
      };
    case GET_PROMO_COUPON_SCOPES_FAIL:
      return {
        ...state,
        isLoadedPromoCouponScopes: false
      };

    case GET_SADUKA_LANGUAGES:
      return {
        ...state,
        isLoadedPromoCouponLanguages: false
      };
    case GET_SADUKA_LANGUAGES_SUCCESS:
      const coupon_lang = action.response.language.map(item => {
        return {
          ...item,
          title: item.name,
          value: item.id,
          default: !!+item.is_default
        }
      });
      const promoCouponLanguagesById = mapObjectize(coupon_lang)
      return {
        ...state,
        isLoadedPromoCouponLanguages: true,
        coupon_lang,
        promoCouponLanguagesById
      };
    case GET_SADUKA_LANGUAGES_FAIL:
      return {
        ...state,
        isLoadedPromoCouponLanguages: false
      };

    case GET_COUPON_FEED_LINK:
      return {
        ...state,
        isLoadedCouponFeedLink: false,
        couponFeedLink: ''
      };
    case GET_COUPON_FEED_LINK_SUCCESS:
      return {
        ...state,
        isLoadedCouponFeedLink: true,
        couponFeedLink: 'https:' + config.SADUKA_URL + action.response.userFeed.api_link,
        couponFeedId: +action.response.userFeed.id,
      };
    case GET_COUPON_FEED_LINK_FAIL:
      return {
        ...state,
        isLoadedCouponFeedLink: false,
        couponFeedLink: 'error'
      };

    case GET_COUPON_LINK:
      return {
        ...state,
        isLoadedCouponLink: false,
        couponFeedLink: ''
      };
    case GET_COUPON_LINK_SUCCESS:
      return {
        ...state,
        isLoadedCouponLink: true,
        couponLinksByCouponId: {
          ...state.couponLinksByCouponId,
          [action.additional.id]: action.response.couponLinks.map(item => ({...item, id: item.channel_id}))
        }
      };
    case GET_COUPON_LINK_FAIL:
      const resp = {
        couponLink: [{
          id: 1,
          name: 'channel 1',
          link: 'http://cityads.com/linkForChannel1',
          iframe: 'http://cityads.com/iframeForChannel1'
        }, {
          id: 2,
          name: 'channel 2',
          link: 'http://cityads.com/linkForChannel2',
          iframe: 'http://cityads.com/iframeForChannel2'
        }, {
          id: 3,
          name: 'channel 3',
          link: 'http://cityads.com/linkForChannel3',
          iframe: 'http://cityads.com/iframeForChannel3'
        }]
      };

      return {
        ...state,
        isLoadedCouponLink: false,
        couponLinksByCouponId: {
          ...state.couponLinksByCouponId,
          [action.additional.id]: config.DEBUG ? resp.couponLink : []
        }
      };

    case GET_COUPON_SECTORING:
      return {
        ...state,
        isLoadedCouponSectoring: false,
        couponFeedLink: ''
      };
    case GET_COUPON_SECTORING_SUCCESS:
      let sectoring = action.response.coupon_sector;

      if (Object.keys(state.couponSectorsById).length) {
        sectoring = sectoring.map(item => ({
          ...state.couponSectorsById[item]
        }))
      } else {
        sectoring = sectoring.map(item => ({
          id: item,
          name: item,
          value: item,
          title: item,
        }));
      }

      return {
        ...state,
        isLoadedCouponSectoring: true,
        sectoring: sectoring
      };
    case GET_COUPON_SECTORING_FAIL:
      return {
        ...state,
        isLoadedCouponSectoring: false,
      };
    case LOAD_COUPON_SECTORS_SUCCESS:
      const couponSectors = action.response.couponSector.map(item => ({
        ...item,
        id: +item.id,
        title: item.name,
        value: +item.id
      })) || [];
      const couponSectorsById = mapObjectize(couponSectors);

      return {
        ...state,
        couponSectorsById,
        sectoring: state.sectoring.map(item => ({
          ...couponSectorsById[item.id]
        }))
      }

    case SEND_SUGGEST_FORM:
      return {
        ...state,
        isSuggestFormSending: true,
        isSuggestFormSent: false,
        suggestFormError: false
      }
    case SEND_SUGGEST_FORM_SUCCESS:
      return {
        ...state,
        isSuggestFormSending: false,
        isSuggestFormSent: true,
        suggestFormError: false
      }
    case SEND_SUGGEST_FORM_FAIL:
      return {
        ...state,
        isSuggestFormSending: false,
        isSuggestFormSent: false,
        suggestFormError: action.response.data?.errors?.request ?? true
      }
    case CLEAR_SUGGEST_OFFER_FORM_STATE:
      return {
        ...state,
        isSuggestFormSending: false,
        isSuggestFormSent: false,
        suggestFormError: false
      }

    case CLEAR_OFFER_LIST:
      return {
        ...state,
        offers: []
      };

    case CLEAR_COUPON_LIST:
      return {
        ...state,
        coupons: []
      };

    case SET_GET_LINK_FORM:
      return {
        ...state,
        getLinkForm: {
          ...state.getLinkForm,
          ...action.form
        }
      }

    case GET_WM_OFFER_URLS:
      return {
        ...state,
        getLinkForm: {}
      }

    case GET_WM_OFFER_SUBSCRIPTION:
      const offerSubscriptionObj = action.additional.offerId.reduce((prev, next) => {
        const obj = [];
        obj.isLoading = true;
        return {...prev, [next]: obj}
      }, {});

      return {
        ...state,
        offerSubscriptionIdsByOfferId: {
          ...state.offerSubscriptionIdsByOfferId,
          ...offerSubscriptionObj
        }
      };

    case GET_WM_OFFER_SUBSCRIPTION_SUCCESS:
      const subscriptions = action.response.wmOfferSubscription.map(item => ({
        ...item,
        is_active: !!+item.is_active,
        action_status: !!+item.action_status,
        isActiveSubscription: !!+item.is_active && !!+item.action_status
      }));
      const subscriptionIdsByOfferId = subscriptions.reduce((acc, item) => ({
        ...acc,
        [item.offer]: [ ...(acc[item.offer] || []), item.id ]
      }), {});

      return {
        ...state,
        offerSubscriptionsById: {
          ...state.offerSubscriptionsById,
          ...mapObjectize(subscriptions, 'id'),
        },
        offerSubscriptionIdsByOfferId: {
          ...state.offerSubscriptionIdsByOfferId,
          ...subscriptionIdsByOfferId,
        },
      };

    case GET_SUBSCRIPTION_STATUSES_SUCCESS:
      const subscription_status = action.response.subscriptionStatus.map(item => ({
        ...item,
        value: item.id,
        title: item.name,
      }));
      const subscription_status_byId = mapObjectize(subscription_status);

      return {
        ...state,
        subscription_status,
        subscription_status_byId
      }

    case GET_OFFERS_BY_IDS:
      return {
        ...state,
        isLoadingOffersByIds: [
          ...state.isLoadingOffersByIds,
          ...action.additional.ids
        ]
      };

    case GET_OFFERS_BY_IDS_SUCCESS:
      const ids = [...action.additional.ids];
      const offersById = action.response.offer.reduce((prev, next) => {
        ids.splice(ids.indexOf(+next.id), 1);
        return {
          ...prev,
          [next.id]: prepareOffer(next, {action, state})
        };
      }, {});

      if (ids.length) {
        ids.forEach(id => {
          offersById[id] = {
            id,
            name: '[not found]'
          };
        });
      }

      return {
        ...state,
        isLoadingOffersByIds: state.isLoadingOffersByIds.filter(id => action.additional.ids.indexOf(id) === -1),
        offersById: {
          ...state.offersById,
          ...offersById
        }
      };

    case GET_OFFERS_BY_IDS_FAIL:
      return {
        ...state,
        isLoadingOffersByIds: state.isLoadingOffersByIds.filter(id => action.additional.ids.indexOf(id) === -1)
      };

    case GET_OFFER_LIST:
      return {
        ...state,
        isLoadingOfferList: {
          ...state.isLoadingOfferList,
          [JSON.stringify(action.additional.params)]: true,
        },
      };

    case GET_OFFER_LIST_SUCCESS:
      return {
        ...state,
        offerListById: {
          ...state.offerListById,
          ...mapObjectize(action.response.offers),
        },
        isLoadingOfferList: {
          ...state.isLoadingOfferList,
          [JSON.stringify(action.additional.params)]: false,
        },
      };

    case GET_OFFER_LIST_FAIL:
      return {
        ...state,
        isLoadingOfferList: {
          ...state.isLoadingOfferList,
          [JSON.stringify(action.additional.params)]: false,
        },
      };

    case CONNECT_TO_OFFER_SUCCESS:
      return {
        ...state,
        accessRequested: {
          ...state.accessRequested,
          [action.additional.offerId]: true,
        }
      }

    case GET_CONNECT_REQUESTS_SUCCESS: {
      const offerConnectRequests = sortBy(action.response.offerConnectRequest, 'created_at');
      const offerIsRequestedByOfferId = offerConnectRequests.reduce((acc, req) => ({
        ...acc,
        [req.offer_id]: req.status_id === OfferConnectRequestStatusId.InProgress,
      }), {});

      return {
        ...state,
        accessRequested: {
          ...state.accessRequested,
          ...offerIsRequestedByOfferId,
        }
      }
    }

    default:
      return state;
  }
}
